<template>
  <ImageItem
    v-if="item.id"
    :src="item[slotData.form.name || slotData.name]"
  ></ImageItem>
</template>

<script>
import ImageItem from "./ImageItem";

export default {
  components: { ImageItem },
  name: "DocumentImageItem",
  props: {
    slotData: {
      type: Object
    },
    item: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped></style>
